import { useMutation } from "@tanstack/react-query";
import { saveAs } from "file-saver";

import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { fetchDataGetBlobFile } from "@/core/api/api-methods";
import { logger } from "@/core/utils/func/logger";
import { payrollEndpoints } from "@/features/payroll/api/endpoints";

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/**
 * Télécharge le modèle Excel à remplir (`GET /PayrollBatches/template`) :
 * feuille « Paie » (Nom complet, Téléphone, Montant GNF, Matricule) + feuille
 * « Exemple ». Seule la première feuille est importée. Le nom de fichier vient
 * du header `Content-Disposition`, avec repli `modele-paie-flashpay.xlsx`.
 */
export const useDownloadPayrollTemplate = () =>
  useMutation({
    mutationKey: ["payroll", "payrollBatches", "template"],
    mutationFn: async () => {
      const { blob, filename } = await fetchDataGetBlobFile({
        url: payrollEndpoints.payrollBatches.template,
        acceptHeader: XLSX_MIME,
      });
      if (blob.type.includes("json")) {
        const text = await blob.text();
        throw new Error(text || "Payroll template download failed");
      }
      saveAs(blob, filename ?? "modele-paie-flashpay.xlsx");
      return filename;
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDownloadPayrollTemplate failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "payroll" }
      );
    },
  });
